import { Brandy as BrandyLeshenUI } from '@leshen/ui'
import React from 'react'

const Brandy = ({ symbol, text, variant, modal, content, disclaimer }) => (
  <BrandyLeshenUI
    text={text}
    variant={variant || 'legal'}
    modal={modal}
    content={content}
    disclaimer={disclaimer}
    symbol={symbol}
  />
)

export default Brandy
